import Variation from './variation';

class Reservation extends Variation{
    
}

export default Reservation;